import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ClientModel } from 'src/app/core/models/members/client/client.model';
import { InvoiceLineItem } from 'src/app/core/models/commerce/invoice-line-item.model';
import { InvoiceModel } from 'src/app/core/models/commerce/invoice.model';
import { UserModel } from 'src/app/core/models/members/user/user.model';
import { AuthMyfileService } from 'src/app/core/services/auth.myfile.service';
import { MyfileApiService } from 'src/app/core/services/myfile-api.service';
import { ToasterNotificationService } from 'src/app/core/services/toaster-notification.service';
import { GlobalComponent } from 'src/app/global-component';
import { environment } from 'src/environments/environment';



@Component({
  selector: 'app-checkout-modal',
  templateUrl: './checkout-modal.component.html',
  styleUrls: ['./checkout-modal.component.scss']
})
export class CheckoutModalComponent implements OnInit{

  payerModel:UserModel = new UserModel
  clientModel : ClientModel = new ClientModel

  invoice: InvoiceModel = new InvoiceModel();
  lineItem: InvoiceLineItem = new InvoiceLineItem();;


  @Input() public model: any; 

  constructor(
    private toasterNotificationService: ToasterNotificationService,
    private myFileApiService: MyfileApiService,
    private modalRef: NgbActiveModal,
    private authService: AuthMyfileService,
    ) {
  }

  ngOnInit(): void {
    if(this.model.id){
      this.requisitionLoad(); 
    }


  }

  requisitionLoad(){

    this.myFileApiService.getUser(this.model.createdById).subscribe((resultModel: UserModel |undefined) => {
      if(resultModel){
        this.payerModel = resultModel;
      }
    })

    this.invoice.clientId = this.model.clientId || ""
    this.invoice.accountId = this.model.accountId  || ""
    this.invoice.matterNumber = this.model.matterNumber || ""
    this.invoice.requisitionId = this.model.id

    this.invoice.accountCompanyName = this.model.account.companyName || ""
    this.invoice.accountFullName = this.model.account.fullName || ""

    this.lineItem.amount = this.model.price
    this.lineItem.description = this.model.type
    this.lineItem.title = "Processing Fee"
    this.lineItem.image = this.model.imageUrl
    this.lineItem.quantity = 1
    this.lineItem.tax = (this.lineItem.amount * GlobalComponent.taxValue);
    this.invoice.lineItems.push(this.lineItem);

    this.updatePrice();
  
    this.loadClient(this.model.client.id)
  }
 
  updatePrice(){
    this.invoice.lineItems.forEach((data: InvoiceLineItem) => {
      this.invoice.subTotal = (this.invoice.subTotal||0) + data.amount;
      this.invoice.hst = (this.invoice.hst||0) + data.tax;
      this.invoice.total = (this.invoice.total||0) + data.amount + data.tax;
    });
  }

  loadClient(clientId: string | undefined){
    if(clientId){
      this.myFileApiService.getClient(clientId).subscribe((resultModel: ClientModel |undefined) => {
        if(resultModel){
          this.clientModel = resultModel;
        }
      })
    }
  }

  getDocumentImageUrl(imageUrl:any) {
    if (imageUrl) {
      var filename = imageUrl.split('/').pop();
      if (filename.includes("120.png")) {
        filename = "myfile_border.jpg";
      }
      return environment.staticImageApiUrl + filename;
    }
    else {
      return GlobalComponent.defaultDocumentImageUrl;
    }
  }

  close(){
    this.modalRef.close();
  }
  removeItem(index:number){
    if(index){
      this.invoice.lineItems.splice(index,1);
    }
  }


  newItem(){
    // Removed
    // this.myModalService.openModal(ModalType.InvoiceItemInput,this.invoice.lineItems) ;
    // this.myModalService.modelChanged.subscribe((result: any)=>{
    //   console.log(this.invoice.lineItems)
    //   this.updatePrice();
    // });
  }

  
}

